import React, { Component } from "react";
import Logout from "../assets/logout.svg";
import Back from "../assets/back.svg";
// import Edit from '../assets/edit.svg'
import Plus from "../assets/plus.svg";
import EditButton from "../components/RulesEditButton";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { NumericFormat } from "react-number-format";
import CustomButton from "../components/CustomButton";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { Modal, Form } from "react-bootstrap";
import Cancel from "../assets/cancel.svg";
import Tick from "../assets/tick.svg";
import { WhisperSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import Paginator from "../components/Paginator";
import filter from "../assets/filter.png";
import moment from "moment-jalaali";
import { isUser, LogoutFunction } from "../static.js";
import Tooltip from "@mui/material/Tooltip";

const mobileRegex = RegExp(/09(0[0-9]|1[1-9]|2[1-9]|3[0-9]|9[0-9])-?[0-9]{7}/);

export default class AdminMessagePatterns extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gridLocaleText: {
        selectAll: "انتخاب همه",
        selectAllSearchResults: "انتخاب همه نتایج جستجو",
        searchOoo: "جستجو...",
        blanks: "خالی",
        noMatches: "پشدا نشد",
        filterOoo: "فیلتر...",
        equals: "مساوی",
        notEqual: "نا مساوی",
        lessThan: "کمتر از",
        greaterThan: "بیشتر از",
        lessThanOrEqual: "کوچکتر مساوی",
        greaterThanOrEqual: "بزرگتر مساوی",
        inRange: "در محدوده",
        inRangeStart: "به",
        inRangeEnd: "از",
        contains: "شامل",
        notContains: "شامل نباشد",
        startsWith: "شروع با",
        endsWith: "پایان با",
        andCondition: "و",
        orCondition: "یا",
        applyFilter: "تایید",
        resetFilter: "راه اندازی مجدد",
        clearFilter: "پاک کردن",
        cancelFilter: "انصراف",
        columns: "ستون ها",
        filters: "فیلترها",
        group: "گروه",
        loadingOoo: "لطفاً شکیبا باشید...",
        noRowsToShow: "هیچ موردی یافت نشد",
        enabled: "فعال",
        sum: "جمع",
        min: "کمترین",
        max: "بیشترین",
        none: "None",
        count: "تعداد",
        avg: "میانگین",
        filteredRows: "فیلتر شده",
        selectedRows: "انتخاب شده",
        totalRows: "جمع ردیف ها",
        totalAndFilteredRows: "ردیف ها",
        page: "صفحه",
        more: "بیشتر",
        to: "تا",
        of: "از",
        next: "بعدی",
        last: "آخرین",
        first: "اولین",
        previous: "قبلی",
      },
      rowData: [],
      columnDefs: [
        {
          headerName: "متن پیام",
          field: "text",
          sortable: true,
          filter: false,
          resizable: false,
          wrapText: true,
          autoHeight: true,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            maxWidth: "500px",
          },
          lockPosition: true,
        },
        {
          headerName: "تایید اپراتور",
          field: "isConfirmedBySepand",
          valueFormatter: this.formatActiveContent,
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نتيجه تاييد",
          field: "resultBySepand",
          cellRenderer: "formatText",
          sortable: true,
          filter: false,
          resizable: false,
          wrapText: true,
          autoHeight: true,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            maxWidth: "300px",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ",
          field: "createdOn",
          valueFormatter: this.formatDateTimeContent,
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "ویرایش",
          field: "id",
          cellRenderer: "fotmatEditCell",
          cellRendererParams: { editItem: this.editItem.bind(this) },
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      frameworkComponents: {
        fotmatEditCell: EditButton,
        formatText: this.formatText,
      },
      ModalShow: false,
      modalType: 0,
      writingProgress: false,
      dataLoading: true,
      currentPage: 0,
      totalPages: 0,
      messageTextValue: "",
      currentMessage: "",
    };

    this.tableGrid = React.createRef();
    this.tableContainer = React.createRef();

    this.GetNotConfirmedSMSTemplates =
      this.GetNotConfirmedSMSTemplates.bind(this);
    this.textHandleChange = this.textHandleChange.bind(this);
  }

  formatDateTimeContent(params) {
    return moment(params.value).format("HH:mm:ss jYYYY/jMM/jDD");
  }

  formatText(params) {
    try {
      if (params.value) return params.value;
      else return "-";
    } catch (error) {
      return "-";
    }
  }

  formatActiveContent(params) {
    if (params.value) return "تایید شده";
    else return "تایید نشده";
  }

  componentDidMount() {
    this.setState({ dataLoading: false });
    // this.GetNotConfirmedSMSTemplates(1);
  }

  GetNotConfirmedSMSTemplates(page) {
    this.setState({ dataLoading: true });
    fetch(
      "https://94.101.187.196/api/Manager/GetNotConfirmedSMSTemplates?page=" +
        page,
      {
        method: "GET",
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);

        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return;
        }

        this.setState({
          dataLoading: false,
          rowData: result.results[0].pageData,
          currentPage: result.results[0].currentPage,
          totalPages: result.results[0].totalPages,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  onFirstPageClick() {
    this.GetNotConfirmedSMSTemplates(1);
  }

  onPreviousPageClick() {
    this.GetNotConfirmedSMSTemplates(this.state.currentPage - 1);
  }

  onNextPageClick() {
    this.GetNotConfirmedSMSTemplates(this.state.currentPage + 1);
  }

  onLastPageClick() {
    this.GetNotConfirmedSMSTemplates(this.state.totalPages);
  }

  onBack() {
    this.props.history.push(
      "/Restaurants/" + this.props.match.params.id + "/Club"
    );
  }

  onLogout() {
    LogoutFunction();
  }

  onFirstDataRendered(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = this.tableGrid.current.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        // console.log('width',width);
        // console.log('tableContainer',this.tableContainer.current.getBoundingClientRect().width-10);
        if (
          width <
          this.tableContainer.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer.current.getBoundingClientRect().width -
            10 -
            width;
          // console.log('def',def);
          if (def > cols.length) {
            let newwidth = def / cols.length;
            // console.log('newwidth',newwidth)
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            // console.log('aa');
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
        // if (width<this.tableContainer.current.getBoundingClientRect().width) params.api.sizeColumnsToFit()
      }, 50);
    } catch (error) {}
  }

  editItem(id) {
    let currentmessage = "";
    this.state.rowData.forEach((element) => {
      if (element.id === id) {
        currentmessage = element.text;
      }
    });
    this.setState({
      ModalShow: true,
      modalType: id,
      writingProgress: false,
      currentMessage: currentmessage,
    });
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onConfirm(status) {
    let data = {
      id: this.state.modalType,
      resultBySepand: this.state.messageTextValue,
      isConfirmedBySepand: status,
    };
    console.log(data);
    // this.setState({ writingProgress: true });
    fetch("https://94.101.187.196/api/Manager/EditNotConfirmedSMSTemplates", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        // console.log("resultttttttttttt: ", result);
        // this.setState({ writingProgress: false });

        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return;
        }

        this.setState({ ModalShow: false });
        this.GetNotConfirmedSMSTemplates(this.state.currentPage);
      })
      .catch((err) => {
        console.log(err);
        this.setState({ writingProgress: false });
      });

    // fetch(
    //   "https://94.101.187.196/api/Manager/EditNotConfirmedSMSTemplates",
    //   {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: "Bearer " + localStorage.getItem("token"),
    //     },
    //     body: JSON.stringify(data),
    //   }
    // )
    //   .then((res) => res.json())
    //   .then((result) => {
    //     console.log(result);
    //     if (result.isSuccessfull) {
    //       toast.success(status ? "الگو با موفقیت تایید شد" : "الگو رد شد", {
    //         position: toast.POSITION.BOTTOM_RIGHT,
    //         hideProgressBar: true,
    //         autoClose: 8000,
    //         toastClassName: "toast",
    //       });
    //       this.setState({ writingProgress: false, ModalShow: false }, () => {
    //         this.GetNotConfirmedSMSTemplates(this.state.currentPage);
    //       });
    //     } else if (result.errorMessage) {
    //       toast.error(result.errorMessage, {
    //         position: toast.POSITION.BOTTOM_RIGHT,
    //         hideProgressBar: true,
    //         autoClose: 8000,
    //         toastClassName: "toast",
    //       });
    //       this.setState({ writingProgress: false });
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     this.setState({ writingProgress: false });
    //   });
  }

  render() {
    return (
      <div className="Login">
        <div className="header">
          <div
            onClick={this.onBack.bind(this)}
            className="linkStyle backButton"
          >
            <img
              src={Back}
              alt=""
              className="backButtonIcon"
              style={{ transform: "rotate(180deg)" }}
            />
            بازگشت
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "fit-content",
              alignItems: "center",
            }}
          >
            <Tooltip title="خروج">
              <div
                onClick={this.onLogout.bind(this)}
                className="linkStyle backButton"
                // data-tip="خروج"
                // data-place="bottom"
              >
                <img src={Logout} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="LoginContent">
          <div className="RestaurantsListTitle">مدیریت الگوی پیام‌ها</div>
          <div className="RestaurantsListSubTitle">
            تایید یا عدم تایید الگوی پیام‌ها
          </div>
        </div>
        <div className="pageContents" ref={this.tableContainer}>
          {/* {!this.state.dataLoading && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                width: "fit-content",
              }}
            >
              <CustomButton
                title="گروه مشترکین جدید"
                imgHeight={20}
                imgWidth={25}
                flexDirection="row-reverse"
                minHeight="35px"
                img={Plus}
                onClick={this.onAddNewButton.bind(this)}
              />
            </div>
          )} */}
          {!this.state.dataLoading && (
            <div className="tableContainer ag-theme-alpine">
              <AgGridReact
                enableRtl={true}
                autoHeight={true}
                animateRows={true}
                enableBrowserTooltips={true}
                tooltipMouseTrack={true}
                suppressSizeToFit={false}
                columnDefs={this.state.columnDefs}
                localeText={this.state.gridLocaleText}
                rowData={this.state.rowData}
                suppressDragLeaveHidesColumns={true}
                suppressMovable={true}
                skipHeaderOnAutoSize={false}
                // onGridReady={this.onGridReady.bind(this)}
                onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                rowHeight={window.innerWidth <= 587 ? 40 : 50}
                headerHeight={window.innerWidth <= 587 ? 40 : 50}
                frameworkComponents={this.state.frameworkComponents}
                // onRowClicked={this.onGridRowClicked.bind(this)}
                // getRowStyle ={function(params){ return { borderWidth:'0px' }}}
                ref={this.tableGrid}
                enableCellTextSelection={true}
                ensureDomOrder={true}
              />
            </div>
          )}
          {!this.state.dataLoading && (
            <div
              style={{
                width: "100%",
                marginTop: "15px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Paginator
                currentPage={this.state.currentPage}
                totalPages={this.state.totalPages}
                onFirstPageClick={this.onFirstPageClick.bind(this)}
                onPreviousPageClick={this.onPreviousPageClick.bind(this)}
                onNextPageClick={this.onNextPageClick.bind(this)}
                onLastPageClick={this.onLastPageClick.bind(this)}
              />
            </div>
          )}

          {this.state.dataLoading && (
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <WhisperSpinner
                size={50}
                color="var(--brown1)"
                frontColor="var(--brown1)"
                backColor="var(--brown1)"
                loading={true}
              />
            </div>
          )}
        </div>
        <Modal
          show={this.state.ModalShow}
          size="md"
          animation={true}
          onHide={this.hideModal.bind(this)}
          centered
        >
          <div className="settingContainer" style={{ padding: "10px" }}>
            <div className="ModalTitleSM">ویرایش الگوی پیام</div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              <div
                className="settingItemContainer"
                style={{ justifyContent: "flex-start" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    lineHeight: "30px",
                  }}
                >
                  {this.state.currentMessage}
                </div>
              </div>

              <div
                className="settingItemContainer"
                style={{ justifyContent: "flex-start" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Control
                      as="textarea"
                      placeholder="متن نتیجه"
                      value={this.state.messageTextValue}
                      onChange={(e) =>
                        this.setState({ messageTextValue: e.target.value })
                      }
                      rows={3}
                      maxLength="100"
                      ref={this.messageInput}
                    />
                  </Form.Group>
                </div>
              </div>
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: "500px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="تایید"
                  loading={this.state.writingProgress}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.onConfirm.bind(this, true)}
                />
              </div>
              <div style={{ minWidth: "10px" }} />
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="رد کردن"
                  loading={this.state.writingProgress}
                  imgHeight={20}
                  imgWidth={25}
                  backColor="var(--red1)"
                  minHeight="35px"
                  img={Tick}
                  onClick={this.onConfirm.bind(this, false)}
                />
              </div>
              <div style={{ minWidth: "10px" }} />
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={this.hideModal.bind(this)}
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
